
import axios from "./productInstance";
import { ProductData } from "@/types/product";

export default async function getProduct (sku: string): Promise<ProductData | null> {
    try {
        const response = await axios.get(`/products/`, {
            params: { sku },
        });

        return response.data as ProductData;
    } catch (error) {
        console.error("Error fetching product:", error);
        return null;
    }
}
